/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { UserAuthentication } from "../../utils/Interfaces";

const initialState: UserAuthentication = {
    id: -1,
    username: "",
    first_name: "",
    last_name: "",
    email: "",
    token: "",
    roles: [],
};

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        login: (state, action: PayloadAction<UserAuthentication>) => {
            state.id = action.payload.id;
            state.username = action.payload.username;
            state.first_name = action.payload.first_name;
            state.last_name = action.payload.last_name;
            state.email = action.payload.email;
            state.token = action.payload.token;
            state.roles = action.payload.roles;
        },
        logout: (state) => {
            state.id = initialState.id;
            state.username = initialState.username;
            state.first_name = initialState.first_name;
            state.last_name = initialState.last_name;
            state.email = initialState.email;
            state.token = initialState.token;
            state.roles = initialState.roles;
        },
    },
});

export const { login, logout } = authSlice.actions;

export const selectUserAuth = (state: RootState) => state.auth;
export const selectToken = (state: RootState) => state.auth.token;
export const selectId = (state: RootState) => state.auth.id;
export const selectUsername = (state: RootState) => state.auth.username;
export const selectFirstName = (state: RootState) => state.auth.first_name;
export const selectLastName = (state: RootState) => state.auth.last_name;
export const selectFullName = (state: RootState) => `${state.auth.first_name} ${state.auth.last_name}`;
export const selectFullNameFormal = (state: RootState) => `${state.auth.last_name}, ${state.auth.first_name}`;
export const selectAtUsername = (state: RootState) => `@${state.auth.username}`;
export const selectEmail = (state: RootState) => state.auth.email;
export const selectRoles = (state: RootState) => state.auth.roles;
export const selectIsAuthenticated = (state: RootState) =>
    state.auth.token !== undefined && state.auth.token !== null && state.auth.token !== "";

export default authSlice.reducer;
